<template>
    <Author 
        :author="author"
        :text="testPerformedByString"    
    />
</template>

<script>
import Author from '@/components/Author.vue';
export default {
    components: { Author },
    props: {
        documentAuthor: {
            type: Object,
            required: false,
            default: null
        }
    },
    computed: {
        author() {
            const hasAuthor = this.$validateContentRelationship(this.documentAuthor);

            return hasAuthor 
                ? this.$store.state.authors[this.documentAuthor.id] 
                : null;
        },
        testPerformedByString() {
            if (!this.author) {
                return null;
            }
            
            return this.$translate('lt_test_performed_by_author', 'Test utfört av {author}')
                .replace('{author}', `<span class="author-name">${this.author.data.name}</span>`);
        }
    }
};
</script>

<style lang="scss" scoped>
    .author-wrapper::v-deep {
        display: flex;
        align-items: center;
        gap: .5rem;
        width: fit-content;
        @include font-size(14px);
        text-decoration: none;
        color: $white;
        &:hover {
            .author-name {
                text-decoration: none;
            }
        }

        .author-image {
            border-radius: 50%;
        }
        .author-name {
            font-weight: bold;
            text-decoration: underline;
        }
    }
</style>